<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#9a6b27"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#9a6b27" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>

        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <div class="purchase-entry-page">
      <!-- Header: Breadcrumbs + Title + Actions -->
      <div class="page-header-container mb-5">
        <!-- Breadcrumbs -->
        <PageBreadcrumb :items="[{ text: 'Purchase', to: '/PurchaseList' }, { text: 'New Purchase Entry' }]" class="mb-1" />

        <!-- Main Header Row -->
        <div class="d-flex flex-wrap align-center justify-space-between gap-3">
          <div class="d-flex align-center flex-wrap gap-2">
            <v-btn
              icon
              class="back-btn mr-1"
              @click="$router.push('/PurchaseList')"
              title="Back to Purchase List"
            >
              <v-icon size="20" color="#475569">mdi-arrow-left</v-icon>
            </v-btn>
            <div>
              <div class="d-flex align-center flex-wrap gap-2">
                <span v-if="Details.bill" class="bill-badge">
                  Bill #{{ billPrefix ? billPrefix + '-' : '' }}{{ Details.bill }}
                </span>
                <span class="status-pill status-draft">
                  <span class="status-dot dot-draft"></span>
                  Draft Bill
                </span>
              </div>
              <div class="page-subtitle">Record incoming jewelry stock, supplier invoice details, and stone charges</div>
            </div>
          </div>

          <!-- Header Action Buttons -->
          <div class="header-actions d-flex align-center flex-wrap gap-2">
            <v-btn
              outlined
              depressed
              class="btn-compact action-outline-btn"
              @click="$router.push('/PurchaseList')"
            >
              <v-icon left x-small class="action-btn-icon">mdi-format-list-bulleted</v-icon>
              Purchase List
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Section 1: Purchase Invoice Information Card -->
      <v-card class="section-card mb-5" elevation="0">
        <div class="section-header d-flex align-center justify-space-between pa-5 px-6">
          <div>
            <h2 class="section-title">Invoice & Supplier Information</h2>
            <div class="section-subtitle">Specify bill prefix, supplier, dates and prevailing Thankam boarding rate</div>
          </div>
        </div>

        <div class="pa-6">
          <v-layout wrap class="mx-n3">
            <!-- Prefix -->
            <v-flex xs6 sm3 md2 class="pa-3 text-left">
              <label class="form-label-elegant">Prefix</label>
              <v-text-field
                color="#9a6b27"
                placeholder="e.g. G"
                v-model="billPrefix"
                outlined
                dense
                hide-details
                class="custom-field"
              ></v-text-field>
            </v-flex>

            <!-- Bill No -->
            <v-flex xs6 sm3 md2 class="pa-3 text-left">
              <label class="form-label-elegant">Bill No.</label>
              <v-text-field
                color="#9a6b27"
                placeholder="Auto"
                v-model="Details.bill"
                outlined
                disabled
                dense
                hide-details
                class="custom-field disabled-field"
              ></v-text-field>
            </v-flex>

            <!-- Purchase Date -->
            <v-flex xs12 sm6 md3 class="pa-3 text-left">
              <label class="form-label-elegant">Purchase Date</label>
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    color="#9a6b27"
                    v-model="billDate"
                    placeholder="Select Date"
                    outlined
                    dense
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                    readonly
                    prepend-inner-icon="mdi-calendar-blank-outline"
                    class="custom-field"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="billDate"
                  no-title
                  color="#9a6b27"
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <!-- Supplier Name -->
            <v-flex xs12 sm12 md5 class="pa-3 text-left">
              <label class="form-label-elegant">Supplier Name</label>
              <v-autocomplete
                color="#9a6b27"
                :items="supplierList"
                v-model="sName"
                placeholder="Select Supplier"
                item-text="supplierName"
                item-value="_id"
                outlined
                :disabled="savedList.length > 0 ? true : false"
                hide-details
                dense
                append-icon="mdi-chevron-down"
                :menu-props="{
                  contentClass: 'modern-dropdown-menu',
                  offsetY: true,
                  transition: 'slide-y-transition',
                  bottom: true,
                  nudgeBottom: 4
                }"
                class="custom-field custom-select-field"
              >
                <template v-slot:item="{ item }">
                  <div class="dropdown-custom-item d-flex align-center justify-space-between w-100 py-1">
                    <div class="d-flex align-center">
                      <div class="dropdown-icon-pill mr-2">
                        <v-icon size="14" color="#9a6b27">mdi-store-outline</v-icon>
                      </div>
                      <span class="dropdown-item-title">{{ item.supplierName }}</span>
                    </div>
                  </div>
                </template>
              </v-autocomplete>
            </v-flex>

            <!-- Invoice No -->
            <v-flex xs12 sm4 md4 class="pa-3 text-left">
              <label class="form-label-elegant">Invoice No.</label>
              <v-text-field
                color="#9a6b27"
                placeholder="Enter Invoice No."
                v-model="invoicenumber"
                outlined
                dense
                hide-details
                class="custom-field"
              ></v-text-field>
            </v-flex>

            <!-- Invoice Date -->
            <v-flex xs12 sm4 md4 class="pa-3 text-left">
              <label class="form-label-elegant">Invoice Date</label>
              <v-menu
                ref="menu3"
                v-model="menu3"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    color="#9a6b27"
                    v-model="invoiceDate"
                    placeholder="Select Date"
                    outlined
                    hide-details
                    dense
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    readonly
                    prepend-inner-icon="mdi-calendar-check-outline"
                    class="custom-field"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="invoiceDate"
                  no-title
                  color="#9a6b27"
                  @input="menu3 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <!-- Thankam Rate -->
            <v-flex xs12 sm4 md4 class="pa-3 text-left">
              <div class="d-flex align-center justify-space-between mb-1">
                <label class="form-label-elegant ma-0">Thankam Rate (₹)</label>
                <button
                  type="button"
                  class="rate-lock-pill"
                  :class="{ 'is-locked': isLock }"
                  @click="isLock ? null : setLock()"
                >
                  <v-icon x-small :color="isLock ? '#9a6b27' : '#64748b'" class="mr-1">
                    {{ isLock ? 'mdi-lock' : 'mdi-lock-open-outline' }}
                  </v-icon>
                  {{ isLock ? 'Locked' : 'Lock Rate' }}
                </button>
              </div>
              <v-text-field
                color="#9a6b27"
                placeholder="0.00"
                v-model="goldRate"
                outlined
                :disabled="isLock == true ? true : false"
                dense
                hide-details
                class="custom-field"
              ></v-text-field>
            </v-flex>

            <!-- Live Gold Rate (used to value Cost / Purchase Cost) -->
            <v-flex xs12 sm4 md4 class="pa-3 text-left">
              <label class="form-label-elegant ma-0">
                Gold Rate (₹)
                <v-icon x-small color="#16a34a" class="ml-1">mdi-flash</v-icon>
                <span class="text-caption" style="color:#16a34a;">Live</span>
              </label>
              <v-text-field
                color="#9a6b27"
                placeholder="0.00"
                :value="liveGoldRate"
                outlined
                disabled
                dense
                hide-details
                class="custom-field disabled-field"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
      </v-card>

      <!-- Section 2: Purchased Items Card -->
      <v-card class="section-card mb-5" elevation="0">
        <div class="section-header d-flex align-center justify-space-between flex-wrap gap-3 pa-5 px-6">
          <div class="d-flex align-center gap-3">
            <div>
              <h2 class="section-title">Purchased Items</h2>
              <div class="section-subtitle">Itemized product breakdown, touch rates, and stone adjustments</div>
            </div>
            <span class="count-badge ml-2" v-if="savedList && savedList.length > 0">
              {{ savedList.length }} {{ savedList.length === 1 ? 'Item' : 'Items' }}
            </span>
          </div>

          <!-- + Add Item button -->
          <v-btn
            dark
            depressed
            class="btn-compact primary-action-btn"
            @click="checkItem()"
          >
            <v-icon left small>mdi-plus</v-icon>
            Add Item
          </v-btn>
        </div>

        <!-- Table if savedList has items -->
        <div v-if="savedList && savedList.length > 0" class="table-responsive">
          <table class="custom-table">
            <thead>
              <tr>
                <th class="text-center" style="width: 48px;">#</th>
                <th class="text-left">Item / Design</th>
                <th class="text-center">Type</th>
                <th class="text-center">Count</th>
                <th class="text-right">Item/Wt (gm)</th>
                <th class="text-right">Net Wt (gm)</th>
                <th class="text-right">Touch (%)</th>
                <th class="text-right">Stone Price (₹)</th>
                <th class="text-right">Stone Wt (gm)</th>
                <th class="text-right">Cost (₹)</th>
                <th class="text-right">Purchase Cost (₹)</th>
                <th class="text-center" style="width: 120px;">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, i) in savedList" :key="i" class="table-row">
                <td class="text-center cell-muted">{{ i + 1 }}</td>
                <td class="text-left">
                  <span v-if="value.supplierDesignCode" class="code-pill">
                    {{ value.supplierDesignCode }}
                  </span>
                  <span v-else class="text-muted">-</span>
                </td>
                <td class="text-center">
                  <span
                    class="type-pill"
                    :class="'type-pill--' + itemTypeLabel(value).toLowerCase()"
                  >{{ itemTypeLabel(value) }}</span>
                </td>
                <td class="text-center font-weight-medium text-dark">
                  {{ value.isBulk ? '-' : (value.count || '-') }}
                </td>
                <td class="text-right text-muted-dark">
                  {{ itemWeightDisplay(value) }}
                </td>
                <td class="text-right font-weight-bold text-dark">
                  {{ value.netWeight ? Number(value.netWeight).toFixed(2) : '-' }}
                </td>
                <td class="text-right font-weight-medium">
                  {{ value.cost ? value.cost + '%' : '-' }}
                </td>
                <td class="text-right font-weight-medium">
                  {{ value.stonePrice ? '₹ ' + Number(value.stonePrice).toLocaleString() : '-' }}
                </td>
                <td class="text-right text-muted-dark">
                  {{ value.stoneWeight || '-' }}
                </td>
                <td class="text-right font-weight-medium">
                  ₹ {{ formatCurrency(getItemCost(value)) }}
                </td>
                <td class="text-right font-weight-bold text-dark">
                  ₹ {{ formatCurrency(getItemPurchaseCost(value)) }}
                </td>
                <td class="text-center">
                  <div class="d-inline-flex align-center gap-1">
                    <v-btn
                      icon
                      x-small
                      class="action-icon-btn edit-action-btn"
                      title="Edit Item"
                      @click="
                        curItem = value;
                        tstcat = value.designId;
                        editdialogue = true;
                        checktype2(curItem);
                        getCategory();
                      "
                    >
                      <v-icon size="15" color="#9a6b27">mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      x-small
                      class="action-icon-btn delete-action-btn"
                      title="Remove Item"
                      @click="dialoge = true; curId = value._id"
                    >
                      <v-icon size="15" color="#ef4444">mdi-delete-outline</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      x-small
                      class="action-icon-btn qr-action-btn"
                      title="View QR Code"
                      @click="showQrTag(value._id)"
                    >
                      <v-icon size="15" color="#2563eb">mdi-qrcode</v-icon>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Empty state if no items -->
        <div v-else class="empty-state-container text-center py-10 px-4">
          <div class="empty-icon-circle mb-3">
            <v-icon size="36" color="#9a6b27">mdi-package-variant-plus</v-icon>
          </div>
          <h3 class="empty-title mb-1">No items added to this purchase yet</h3>
          <p class="empty-subtitle mb-4">Click below to add jewelry designs, weights, and stone charges</p>
          <v-btn
            dark
            depressed
            class="btn-compact primary-action-btn"
            @click="checkItem()"
          >
            <v-icon left x-small>mdi-plus</v-icon>
            Add First Item
          </v-btn>
        </div>

        <!-- Summary strip & Action bar (shown when items exist) -->
        <div v-if="savedList && savedList.length > 0" class="totals-action-strip pa-4 px-6 d-flex flex-wrap align-center justify-space-between gap-3">
          <!-- Totals summary pills -->
          <div class="d-flex align-center flex-wrap gap-3">
            <div class="summary-pill">
              <div class="summary-pill-icon badge-amber">
                <v-icon size="15" color="#9a6b27">mdi-scale-balance</v-icon>
              </div>
              <div>
                <div class="summary-pill-label">Total Net Weight</div>
                <div class="summary-pill-val">{{ totalnetweight ? totalnetweight.toFixed(2) : '0.00' }} <span class="unit">gm</span></div>
              </div>
            </div>

            <div class="summary-pill">
              <div class="summary-pill-icon badge-golden">
                <v-icon size="15" color="#d97706">mdi-gold</v-icon>
              </div>
              <div>
                <div class="summary-pill-label">Total Thankam Weight (To Be Paid)</div>
                <div class="summary-pill-val text-amber-dark">{{ totalPayableFineWeight ? totalPayableFineWeight.toFixed(2) : '0.00' }} <span class="unit">gm</span></div>
              </div>
            </div>

            <div class="summary-pill">
              <div class="summary-pill-icon badge-green">
                <v-icon size="15" color="#16a34a">mdi-currency-inr</v-icon>
              </div>
              <div>
                <div class="summary-pill-label">Total Purchase Amount</div>
                <div class="summary-pill-val text-green font-weight-bold">₹ {{ formatCurrency(totalEstimatedCost) }}</div>
              </div>
            </div>
          </div>

          <!-- Actions -->
          <div class="d-flex align-center flex-wrap gap-2">
            <v-btn
              outlined
              depressed
              class="btn-compact action-outline-btn submit-outline-btn"
              @click="validate1()"
            >
              <v-icon left x-small class="action-btn-icon">mdi-clock-outline</v-icon>
              Save & Settle Later
            </v-btn>
            <v-btn
              v-if="bill"
              dark
              depressed
              class="btn-compact primary-action-btn submit-primary-btn"
              @click="validate2()"
            >
              <v-icon left x-small>mdi-check-decagram</v-icon>
              Save & Generate Bill
            </v-btn>
          </div>
        </div>
      </v-card>

      <!-- Delete Confirmation Dialog -->
      <v-dialog width="420px" v-model="dialoge">
        <v-card class="dialog-card pa-6 text-center" elevation="0">
          <div class="delete-icon-circle mx-auto mb-3">
            <v-icon size="28" color="#ef4444">mdi-trash-can-outline</v-icon>
          </div>
          <h3 class="dialog-title mb-1">Remove Item?</h3>
          <p class="dialog-subtitle mb-5">Are you sure you want to remove this purchased item? This action cannot be undone.</p>
          <div class="d-flex align-center justify-center gap-3">
            <v-btn
              outlined
              depressed
              class="btn-compact action-outline-btn px-5"
              @click="dialoge = false"
            >Cancel</v-btn>
            <v-btn
              dark
              depressed
              class="btn-compact delete-confirm-btn px-5"
              @click="deleteStaff()"
            >Delete</v-btn>
          </div>
        </v-card>
      </v-dialog>

      <!-- QR Code Dialog -->
      <v-dialog width="420px" v-model="qrDialog">
        <v-card class="dialog-card pa-6 text-center" elevation="0">
          <div class="d-flex align-center justify-space-between mb-3">
            <span class="section-title">Item QR Tag</span>
            <v-btn icon small @click="qrDialog = false">
              <v-icon size="18" color="#64748b">mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="qr-code-wrapper py-4 px-2 my-2">
            <img v-if="qrCodeDataUrl" :src="qrCodeDataUrl" style="width: 200px; height: 200px" id="printableQr" />
          </div>
          <div class="d-flex align-center justify-end gap-2 mt-4">
            <v-btn outlined depressed class="btn-compact action-outline-btn" @click="qrDialog = false">Close</v-btn>
            <v-btn dark depressed class="btn-compact primary-action-btn" @click="printQrTag()">
              <v-icon left x-small>mdi-printer</v-icon>
              Print Tag
            </v-btn>
          </div>
        </v-card>
      </v-dialog>

      <!-- Add Item Dialog -->
      <v-dialog width="800px" v-model="addnewItem" persistent>
        <v-form ref="myForm">
          <v-card class="dialog-card pa-0 overflow-hidden" elevation="0">
            <div class="dialog-header d-flex align-center justify-space-between pa-4 px-6">
              <div class="d-flex align-center">
                <div class="section-icon-badge mr-3">
                  <v-icon size="17" color="#9a6b27">mdi-plus-circle-outline</v-icon>
                </div>
                <div>
                  <h3 class="dialog-title">Add Purchase Item</h3>
                  <div class="dialog-subtitle">Select category, enter item weights, touch rate and stone charges</div>
                </div>
              </div>
              <v-btn icon small @click="addnewItem = false; resetForm(); itemz = []; variantPreview = []">
                <v-icon size="20" color="#64748b">mdi-close</v-icon>
              </v-btn>
            </div>

            <div class="dialog-body pa-6">
              <!-- Variants queued in this modal, not yet saved -->
              <div v-if="variantPreview.length > 0" class="mb-4">
                <label class="form-label-elegant">Queued Variants ({{ variantPreview.length }})</label>
                <div
                  v-for="(v, vi) in variantPreview"
                  :key="vi"
                  class="d-flex align-center justify-space-between pa-2 mb-1"
                  style="background:#faf7f0; border-radius:6px; border:1px solid #eee2cc;"
                >
                  <span style="font-size:13px;">
                    {{ v.categoryName }} / {{ v.itemName }} / {{ v.designName }} —
                    <template v-if="v.isBulk">Bulk lot,</template>
                    <template v-else>
                      {{ v.countOrSplit }}{{ v.count ? (' x' + v.count) : '' }},
                      {{ v.itemPerWeight }}gm/item,
                    </template>
                    Net {{ v.netWeight }}gm, Touch {{ v.cost }}%
                    <template v-if="v.HUID">, HUID {{ v.HUID }}</template>
                  </span>
                  <v-btn icon x-small @click="removeVariant(vi)">
                    <v-icon size="16" color="#b91c1c">mdi-delete-outline</v-icon>
                  </v-btn>
                </div>
              </div>

              <v-layout wrap class="mx-n2">
                <!-- Category -->
                <v-flex xs12 sm4 class="pa-2 text-left">
                  <label class="form-label-elegant">Category</label>
                  <v-select
                    color="#9a6b27"
                    :items="categoryList"
                    v-model="purchaseItem.test"
                    placeholder="Select Category"
                    item-text="name"
                    item-value="_id"
                    @input="getItem()"
                    outlined
                    hide-details
                    dense
                    append-icon="mdi-chevron-down"
                    :menu-props="{
                      contentClass: 'modern-dropdown-menu',
                      offsetY: true,
                      transition: 'slide-y-transition',
                      bottom: true,
                      nudgeBottom: 4
                    }"
                    class="custom-field custom-select-field"
                  >
                    <template v-slot:selection="{ item }">
                      <div class="d-inline-flex align-center">
                        <span class="category-color-dot mr-2" :class="getCategoryDotClass(item.name)"></span>
                        <span class="dropdown-selection-text">{{ item.name }}</span>
                      </div>
                    </template>
                    <template v-slot:item="{ item }">
                      <div class="dropdown-custom-item d-flex align-center w-100 py-1">
                        <span class="category-color-dot mr-2" :class="getCategoryDotClass(item.name)"></span>
                        <span class="dropdown-item-title">{{ item.name }}</span>
                      </div>
                    </template>
                  </v-select>
                </v-flex>

                <!-- Item -->
                <v-flex xs12 sm4 class="pa-2 text-left">
                  <label class="form-label-elegant">Item</label>
                  <v-select
                    color="#9a6b27"
                    :items="ItemList"
                    v-model="purchaseItem.test2"
                    placeholder="Select Item"
                    item-text="name"
                    item-value="_id"
                    @input="getDesign()"
                    outlined
                    hide-details
                    dense
                    append-icon="mdi-chevron-down"
                    :menu-props="{
                      contentClass: 'modern-dropdown-menu',
                      offsetY: true,
                      transition: 'slide-y-transition',
                      bottom: true,
                      nudgeBottom: 4
                    }"
                    class="custom-field custom-select-field"
                  >
                    <template v-slot:selection="{ item }">
                      <div class="d-inline-flex align-center">
                        <v-icon size="13" color="#9a6b27" class="mr-2">mdi-ring</v-icon>
                        <span class="dropdown-selection-text">{{ item.name }}</span>
                      </div>
                    </template>
                    <template v-slot:item="{ item }">
                      <div class="dropdown-custom-item d-flex align-center w-100 py-1">
                        <div class="dropdown-icon-pill mr-2">
                          <v-icon size="13" color="#64748b">mdi-ring</v-icon>
                        </div>
                        <span class="dropdown-item-title">{{ item.name }}</span>
                      </div>
                    </template>
                  </v-select>
                </v-flex>

                <!-- Design -->
                <v-flex xs12 sm4 class="pa-2 text-left">
                  <label class="form-label-elegant">Design</label>
                  <v-select
                    color="#9a6b27"
                    :items="designList"
                    v-model="purchaseItem.design"
                    placeholder="Select Design"
                    item-text="name"
                    item-value="_id" 
                    @change="checktype(purchaseItem.design)"
                    outlined
                    hide-details
                    dense
                    append-icon="mdi-chevron-down"
                    :menu-props="{
                      contentClass: 'modern-dropdown-menu',
                      offsetY: true,
                      transition: 'slide-y-transition',
                      bottom: true,
                      nudgeBottom: 4
                    }"
                    class="custom-field custom-select-field"
                  >
                    <template v-slot:selection="{ item }">
                      <div class="d-inline-flex align-center">
                        <v-icon size="13" color="#9a6b27" class="mr-2">mdi-shape-outline</v-icon>
                        <span class="dropdown-selection-text">{{ item.name }}</span>
                      </div>
                    </template>
                    <template v-slot:item="{ item }">
                      <div class="dropdown-custom-item d-flex align-center w-100 py-1">
                        <div class="dropdown-icon-pill mr-2">
                          <v-icon size="13" color="#64748b">mdi-shape-outline</v-icon>
                        </div>
                        <span class="dropdown-item-title">{{ item.name }}</span>
                      </div>
                    </template>
                  </v-select>
                </v-flex>

                <!-- Entry mode: Count / Split / Bulk (defaults from the design, editable per purchase) -->
                <v-flex xs12 class="pa-2 text-left" v-if="dtype == true">
                  <label class="form-label-elegant">Entry Mode</label>
                  <div class="entry-mode-toggle">
                    <button
                      v-for="m in entryModes"
                      :key="m.value"
                      type="button"
                      class="entry-mode-option"
                      :class="{ active: selectedCountOrSplit == m.value }"
                      @click="setEntryMode(m.value)"
                    >
                      <v-icon size="15" class="mr-1">{{ m.icon }}</v-icon>
                      {{ m.label }}
                    </button>
                  </div>
                  <div class="entry-mode-hint">{{ entryModeHint(selectedCountOrSplit) }}</div>
                </v-flex>

                <!-- Count - Count & Split modes -->
                <v-flex xs12 sm4 class="pa-2 text-left" v-if="dtype == true && selectedCountOrSplit != 'Bulk'">
                  <label class="form-label-elegant">Count (pcs)</label>
                  <v-text-field
                    color="#9a6b27"
                    @input="cal1()"
                    placeholder="No. of pieces"
                    v-model="purchaseItem.Count"
                    outlined
                    type="number"
                    dense
                    hide-details
                    class="custom-field"
                  ></v-text-field>
                </v-flex>

                <!-- Item / Weight (gm) - Count mode only -->
                <v-flex xs12 sm4 class="pa-2 text-left" v-if="selectedCountOrSplit == 'Count'">
                  <label class="form-label-elegant">Item / Weight (gm)</label>
                  <v-text-field
                    color="#9a6b27"
                    @input="cal1()"
                    placeholder="Weight of one piece"
                    v-model="purchaseItem.wt"
                    outlined
                    type="number"
                    dense
                    hide-details
                    class="custom-field"
                  ></v-text-field>
                </v-flex>

                <!-- Total Weight (gm) - Split & Bulk modes -->
                <v-flex xs12 sm4 class="pa-2 text-left" v-if="selectedCountOrSplit == 'Split' || selectedCountOrSplit == 'Bulk'">
                  <label class="form-label-elegant">{{ selectedCountOrSplit == 'Bulk' ? 'Total Lot Weight (gm)' : 'Total Weight (gm)' }}</label>
                  <v-text-field
                    color="#9a6b27"
                    @input="cal1()"
                    placeholder="Gross weight incl. stones"
                    v-model="purchaseItem.totalWt"
                    outlined
                    type="number"
                    dense
                    hide-details
                    class="custom-field"
                  ></v-text-field>
                </v-flex>

                <!-- Per Item Weight (gm) - Split mode only, auto-derived -->
                <v-flex xs12 sm4 class="pa-2 text-left" v-if="selectedCountOrSplit == 'Split'">
                  <label class="form-label-elegant">Per Item Weight (gm)</label>
                  <v-text-field
                    color="#9a6b27"
                    placeholder="Auto calculated"
                    disabled
                    :value="purchaseItem.wt ? Number(purchaseItem.wt).toFixed(3) : 0"
                    outlined
                    dense
                    hide-details
                    class="custom-field disabled-field"
                  ></v-text-field>
                </v-flex>

                <!-- Total Stone Price -->
                <v-flex xs12 sm4 class="pa-2 text-left">
                  <label class="form-label-elegant">Stone Price (₹)</label>
                  <v-text-field
                    color="#9a6b27"
                    placeholder="Stone Price"
                    v-model="purchaseItem.StPrice"
                    outlined
                    dense
                    type="number"
                    hide-details
                    class="custom-field"
                  ></v-text-field>
                </v-flex>

                <!-- Total Stone Wt -->
                <v-flex xs12 sm4 class="pa-2 text-left">
                  <label class="form-label-elegant">Stone Weight (gm)</label>
                  <v-text-field
                    color="#9a6b27"
                    @input="cal1()"
                    placeholder="Stone Weight"
                    v-model="purchaseItem.StoneWt"
                    outlined
                    dense
                    type="number"
                    hide-details
                    class="custom-field"
                  ></v-text-field>
                </v-flex>

                <!-- Net.Wt -->
                <v-flex xs12 sm4 class="pa-2 text-left">
                  <label class="form-label-elegant">Net Weight (gm)</label>
                  <v-text-field
                    color="#9a6b27"
                    @input="cal2()"
                    placeholder="Net Weight"
                    disabled
                    type="number"
                    v-model="purchaseItem.netwt"
                    outlined
                    dense
                    hide-details
                    class="custom-field disabled-field"
                  ></v-text-field>
                </v-flex>

                <!-- Touch (%) -->
                <v-flex xs12 sm4 class="pa-2 text-left">
                  <label class="form-label-elegant">Touch (%)</label>
                  <v-text-field
                    color="#9a6b27"
                    :rules="[maxValueRule]"
                    @input="cal2()"
                    type="number"
                    placeholder="Touch (%)"
                    v-model="purchaseItem.cost"
                    outlined
                    maxlength="3"
                    dense
                    hide-details="auto"
                    class="custom-field"
                  ></v-text-field>
                </v-flex>

                <!-- HUIDs - issued by BIS, one per piece; each hallmarked piece becomes its own stock item -->
                <v-flex xs12 class="pa-2 text-left">
                  <label class="form-label-elegant">
                    HUID (Hallmark ID)
                    <span v-if="selectedCountOrSplit == 'Count' && purchaseItem.Count > 0" class="huid-counter">
                      {{ (purchaseItem.HUIDs || []).length }} / {{ purchaseItem.Count }} pcs
                    </span>
                  </label>
                  <v-combobox
                    v-model="purchaseItem.HUIDs"
                    @change="onHUIDsChange"
                    :disabled="selectedCountOrSplit != 'Count'"
                    :placeholder="selectedCountOrSplit == 'Count' ? 'Type or scan each piece\'s HUID, press Enter (e.g. AB12C3)' : 'HUIDs are entered on Count pieces'"
                    :delimiters="[',', ' ', ';']"
                    multiple
                    small-chips
                    deletable-chips
                    hide-no-data
                    append-icon=""
                    color="#9a6b27"
                    outlined
                    dense
                    hide-details
                    class="custom-field huid-field"
                  ></v-combobox>
                  <div class="entry-mode-hint">
                    Optional. One 6-character BIS code per piece. Each hallmarked piece is stocked separately; pieces without a HUID stay in one lot.
                  </div>
                </v-flex>
              </v-layout>
            </div>

            <div class="dialog-footer pa-4 px-6 d-flex align-center justify-end gap-2">
              <v-btn
                outlined
                depressed
                class="btn-compact action-outline-btn"
                @click="addnewItem = false; resetForm(); itemz = []; variantPreview = []"
              >Cancel</v-btn>
              <v-btn
                outlined
                depressed
                class="btn-compact action-outline-btn"
                @click="valid(false)"
              >
                <v-icon left x-small>mdi-plus</v-icon>
                Add Another Variant
              </v-btn>
              <v-btn
                dark
                depressed
                class="btn-compact primary-action-btn"
                @click="valid(true)"
              >
                <v-icon left x-small>mdi-check</v-icon>
                Add to Purchase
              </v-btn>
            </div>
          </v-card>
        </v-form>
      </v-dialog>

      <!-- Edit Item Dialog -->
      <v-dialog width="750px" v-model="editdialogue" persistent>
        <v-form ref="myForm">
          <v-card class="dialog-card pa-0 overflow-hidden" elevation="0">
            <div class="dialog-header d-flex align-center justify-space-between pa-4 px-6">
              <div class="d-flex align-center">
                <div class="section-icon-badge mr-3">
                  <v-icon size="17" color="#9a6b27">mdi-pencil</v-icon>
                </div>
                <div>
                  <h3 class="dialog-title">Edit Item : {{ curItem.supplierDesignCode }}</h3>
                  <div class="dialog-subtitle">Update item count, weights, stone price and seller cost</div>
                </div>
              </div>
              <v-btn icon small @click="editdialogue = false; dtype2 = false">
                <v-icon size="20" color="#64748b">mdi-close</v-icon>
              </v-btn>
            </div>

            <div class="dialog-body pa-6">
              <v-layout wrap class="mx-n2">
                <v-flex xs12 class="pa-2 text-left" v-if="dtype2==true">
                  <label class="form-label-elegant">Entry Mode</label>
                  <div class="entry-mode-toggle">
                    <button
                      v-for="m in entryModes"
                      :key="m.value"
                      type="button"
                      class="entry-mode-option"
                      :class="{ active: curItem.countOrSplit == m.value }"
                      @click="setEditEntryMode(m.value)"
                    >
                      <v-icon size="15" class="mr-1">{{ m.icon }}</v-icon>
                      {{ m.label }}
                    </button>
                  </div>
                  <div class="entry-mode-hint">{{ entryModeHint(curItem.countOrSplit) }}</div>
                </v-flex>

                <v-flex xs12 sm4 class="pa-2 text-left" v-if="dtype2==true && curItem.countOrSplit != 'Bulk'">
                  <label class="form-label-elegant">Count (pcs)</label>
                  <v-text-field
                    color="#9a6b27"
                    @input="editcal1()"
                    placeholder="No. of pieces"
                    v-model="curItem.count"
                    outlined
                    type="number"
                    dense
                    hide-details
                    class="custom-field"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 class="pa-2 text-left" v-if="curItem.countOrSplit == 'Count'">
                  <label class="form-label-elegant">Item / Weight (gm)</label>
                  <v-text-field
                    color="#9a6b27"
                    @input="editcal1()"
                    placeholder="Weight of one piece"
                    v-model="curItem.itemPerWeight"
                    outlined
                    type="number"
                    dense
                    hide-details
                    class="custom-field"
                  ></v-text-field>
                </v-flex>

                <!-- Total Weight (gm) - Split & Bulk modes -->
                <v-flex xs12 sm4 class="pa-2 text-left" v-if="curItem.countOrSplit == 'Split' || curItem.countOrSplit == 'Bulk'">
                  <label class="form-label-elegant">{{ curItem.countOrSplit == 'Bulk' ? 'Total Lot Weight (gm)' : 'Total Weight (gm)' }}</label>
                  <v-text-field
                    color="#9a6b27"
                    @input="editcal1()"
                    placeholder="Gross weight incl. stones"
                    v-model="curItem.totalWeight"
                    outlined
                    type="number"
                    dense
                    hide-details
                    class="custom-field"
                  ></v-text-field>
                </v-flex>

                <!-- Per Item Weight (gm) - Split mode only, auto-derived -->
                <v-flex xs12 sm4 class="pa-2 text-left" v-if="curItem.countOrSplit == 'Split'">
                  <label class="form-label-elegant">Per Item Weight (gm)</label>
                  <v-text-field
                    color="#9a6b27"
                    placeholder="Auto calculated"
                    disabled
                    :value="curItem.itemPerWeight ? Number(curItem.itemPerWeight).toFixed(3) : 0"
                    outlined
                    dense
                    hide-details
                    class="custom-field disabled-field"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 class="pa-2 text-left">
                  <label class="form-label-elegant">Stone Price (₹)</label>
                  <v-text-field
                    color="#9a6b27"
                    placeholder="Stone Price"
                    v-model="curItem.stonePrice"
                    outlined
                    dense
                    type="number"
                    hide-details
                    class="custom-field"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 class="pa-2 text-left">
                  <label class="form-label-elegant">Stone Weight (gm)</label>
                  <v-text-field
                    color="#9a6b27"
                    @input="editcal1()"
                    placeholder="Stone Weight"
                    v-model="curItem.stoneWeight"
                    outlined
                    dense
                    type="number"
                    hide-details
                    class="custom-field"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 class="pa-2 text-left">
                  <label class="form-label-elegant">Net Weight (gm)</label>
                  <v-text-field
                    color="#9a6b27"
                    @input="editcal2()"
                    placeholder="Net Weight"
                    disabled
                    type="number"
                    v-model="curItem.netWeight"
                    outlined
                    dense
                    hide-details
                    class="custom-field disabled-field"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 class="pa-2 text-left">
                  <label class="form-label-elegant">Seller Cost (%)</label>
                  <v-text-field
                    color="#9a6b27"
                    @input="editcal2()"
                    placeholder="Seller Cost"
                    v-model="curItem.cost"
                    outlined
                    type="number"
                    maxlength="3"
                    dense
                    hide-details
                    class="custom-field"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 class="pa-2 text-left">
                  <label class="form-label-elegant">HUID (Hallmark ID)</label>
                  <v-text-field
                    color="#9a6b27"
                    :placeholder="huidAllowed(curItem.countOrSplit, curItem.count) ? 'As marked on piece, e.g. AB12C3' : 'Single piece only'"
                    :disabled="!huidAllowed(curItem.countOrSplit, curItem.count) && !curItem.HUID"
                    :value="curItem.HUID"
                    @input="$set(curItem, 'HUID', cleanHUID($event))"
                    :rules="[huidRule]"
                    maxlength="6"
                    outlined
                    dense
                    hide-details="auto"
                    class="custom-field huid-field"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </div>

            <div class="dialog-footer pa-4 px-6 d-flex align-center justify-end gap-2">
              <v-btn
                outlined
                depressed
                class="btn-compact action-outline-btn"
                @click="editdialogue = false; dtype2 = false"
              >Cancel</v-btn>
              <v-btn
                dark
                depressed
                class="btn-compact primary-action-btn"
                @click="editCheck()"
              >
                <v-icon left x-small>mdi-check</v-icon>
                Save Changes
              </v-btn>
            </div>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog
      v-model="queryPopUpDialog"
      persistent
      :width="
        $vuetify.breakpoint.name == 'xs'
          ? '100vw'
          : $vuetify.breakpoint.name == 'sm'
          ? '70vw'
          : $vuetify.breakpoint.name == 'md'
          ? '56vw'
          : $vuetify.breakpoint.name == 'lg'
          ? '46vw'
          : '38vw'
      "
    >
      <v-card class="boarding-dialog-card" tile>
        <div class="boarding-dialog-header">
          <div class="boarding-header-icon">
            <v-icon color="#0f172a" size="20">mdi-currency-inr</v-icon>
          </div>
          <div>
            <div class="boarding-title">Today's Metal Rates</div>
            <div class="boarding-subtitle">Set today's rates once to continue with purchase entry</div>
          </div>
        </div>

        <div class="boarding-rate-grid">
          <div class="boarding-rate-card">
            <div class="boarding-rate-card-header">
              <div class="boarding-rate-img-pill">
                <img src="../../../assets/icons/rate_thankam.jpg" alt="Thankam" class="boarding-rate-img" />
              </div>
              <div class="boarding-rate-label">Thankam <span>Per gm</span></div>
            </div>
            <v-text-field
              autofocus
              placeholder="0"
              class="boarding-rate-input"
              prefix="₹"
              v-model="thankamRate"
              type="number"
              outlined
              dense
              hide-details
            ></v-text-field>
          </div>

          <div class="boarding-rate-card">
            <div class="boarding-rate-card-header">
              <div class="boarding-rate-img-pill">
                <img src="../../../assets/icons/rate_gold.jpg" alt="Gold" class="boarding-rate-img" />
              </div>
              <div class="boarding-rate-label">Gold <span>Per gm</span></div>
            </div>
            <v-text-field
              prefix="₹"
              v-model="gold"
              type="number"
              placeholder="0"
              class="boarding-rate-input"
              outlined
              dense
              hide-details
            ></v-text-field>
          </div>

          <div class="boarding-rate-card">
            <div class="boarding-rate-card-header">
              <div class="boarding-rate-img-pill">
                <img src="../../../assets/icons/rate_silver.jpg" alt="Silver" class="boarding-rate-img" />
              </div>
              <div class="boarding-rate-label">Silver <span>Per gm</span></div>
            </div>
            <v-text-field
              v-model="silverRate"
              type="number"
              placeholder="0"
              class="boarding-rate-input"
              prefix="₹"
              outlined
              dense
              hide-details
            ></v-text-field>
          </div>

          <div class="boarding-rate-card">
            <div class="boarding-rate-card-header">
              <div class="boarding-rate-img-pill">
                <img src="../../../assets/icons/rate_platinum.jpg" alt="Platinum" class="boarding-rate-img" />
              </div>
              <div class="boarding-rate-label">Platinum <span>Per gm</span></div>
            </div>
            <v-text-field
              prefix="₹"
              v-model="platinumRate"
              type="number"
              placeholder="0"
              class="boarding-rate-input"
              outlined
              dense
              hide-details
            ></v-text-field>
          </div>

          <div class="boarding-rate-card boarding-rate-card-full">
            <div class="boarding-rate-card-header">
              <div class="boarding-rate-img-pill">
                <img src="../../../assets/icons/rate_diamond.jpg" alt="Diamond" class="boarding-rate-img" />
              </div>
              <div class="boarding-rate-label">Diamond</div>
            </div>
            <v-text-field
              prefix="₹"
              v-model="diamond"
              type="number"
              placeholder="0"
              class="boarding-rate-input"
              outlined
              dense
              hide-details
            ></v-text-field>
          </div>
        </div>

        <div class="boarding-dialog-footer">
          <v-btn
            dark
            depressed
            class="boarding-save-btn text-capitalize"
            @click="EditRate()"
          >
            <v-icon left small>mdi-content-save-outline</v-icon>
            Save Rates
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
       //bordingrate
       gold: "",
      thankamRate: "",
      silverRate: "",
      platinumRate: "",
      diamond: "",
      queryPopUpDialog: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      //
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      testId: null,
      timeout: 2000,
      msg: null,
      itemz: [],
      totalPurchaseCost: null,
      totalMakingCharge: null,
      username: null,
      name: null,
      address: null,
      phone: null,
      email: null,
      addnewItem: false,
      billDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      bill: null,
      purchaseno: null,
      thankamcode: null,
      sName: null,
      thankamrate: null,
      invoiceDate1: null,
      makingcost: null,
      savedList: [],
      Details: [],
      designList: [],
      menu3: false,
      menu2: false,
      returndata: null,
      check: false,
      categoryList: [],
      ItemList: [],
      removeitemIndex: null,
      dialoge: false,
      qrDialog: false,
      qrCodeDataUrl: null,
      HSN: null,
      supplierList: [],
      totalnetweight: null,
      billPrefix: "",
      invoicenumber: null,
      invoiceDate: null,
      finalTotal: null,
      // goldRate: localStorage.getItem("thankamRate"),
      tst1: null,
      tst2: null,
      tst3: null, 
      test4: null,
      isLock: false,
      CodeList: [],
      purchaseItem: {
        test: null,
        test2: null,
        design: null,
        Count:"",
        cost: 0,
        netwt: 0,
        totalamt: 0,
        wt: 0,
        totalWt: 0,
        TotalCost: 0,
        StPrice: 0,
        StoneWt: 0,
        MarkingC: 0,
        HUID: null,
        HUIDs: [],
        // discount: 0,
        // adtouchrate: 0,
        // admakingcharge: 0,
      },
      // Variants queued inside the Add Purchase Item modal before submit
      variantPreview: [],
      singleitem: {
        categoryId: null,
        itemId: null,
        designId: null,
        // designName: null,
        countOrSplit: null,
        isBulk: false,
        count: null,
        // grossWeight: null,
        itemPerWeight: null,
        cost: null,
        totalAmount: null,
        stonePrice: null,
        stoneWeight: null,
        makingCharge: null,
        HUID: null,
        // boardingRate: null,
        netWeight: null,
        // totalAmount: null,
        // hsnCodeId: null,
      },
      tstcat: {},
      curItem: [],
      editdialogue: false,
      curId: null,
      paymentTypes: [],
      checkvalue: false,
      purchaseId: null,
      editdialogueOld:false,
      payment: [
        {
          paymentType: null,
          payAmount: null,
        },
      ],
      thankamDetails: [
        {
          thankamId: "63d3a2d42d13b00bbea3a98f",
          boardingRate: null,
          thankamWeight: null,
          batchCode: null,
        },
      ],
      newdate: null,
      new: null,
      GstStat: "GST",
      dtype:false,
      dtype2:false,
      selectedCountOrSplit: "",
      entryModes: [
        { value: "Count", label: "Count", icon: "mdi-counter" },
        { value: "Split", label: "Split", icon: "mdi-call-split" },
        { value: "Bulk", label: "Bulk", icon: "mdi-weight-gram" },
      ],
      myGoldRate: localStorage.getItem("thankamRate") || 0,
      // Live market Gold Rate (per gram) from Rate Master, used for Cost / Purchase Cost.
      // Distinct from Thankam Rate, which is only used at settlement.
      liveGoldRate: 0
    };
  },
  // watch: {
  //  purchaseItem:{

  //     deep:true,
  //     handler: function (){
  //       if(this.purchaseItem.test){
  //     this.getItem();
  //       }
  //        if(this.purchaseItem.test2){
  //     this.getDesign();
  //       }
  //     }
  // }

  // },
  mounted() {
    this.getBording();
    this.userinfo();
    this.getBill();
    this.getSupplier();
    this.getHSN();
  },
  computed: {
    totalPayableFineWeight() {
      if (!this.savedList || this.savedList.length === 0) return 0;
      return this.savedList.reduce((acc, item) => acc + (parseFloat(item.pendingGoldWeight) || 0), 0);
    },
    totalEstimatedCost() {
      if (this.finalTotal && Number(this.finalTotal) > 0) {
        return Number(this.finalTotal);
      }
      if (this.totalCostWithGst && Number(this.totalCostWithGst) > 0) {
        return Number(this.totalCostWithGst);
      }
      // Cost / Purchase Cost are valued at the live Gold Rate, not the Thankam Rate
      // (Thankam Rate is only used at settlement to convert Purchase Cost into gold weight owed).
      const rate = parseFloat(this.liveGoldRate) || 0;
      if (!this.savedList || this.savedList.length === 0) return 0;
      return this.savedList.reduce((acc, item) => {
        const netWeight = parseFloat(item.netWeight) || 0;
        const touch = parseFloat(item.cost) || 0;
        // Cost = Net Weight * (Touch / 100) * (Gold Rate / 100)
        const cost = netWeight * (touch / 100) * (rate / 100);
        // Purchase Cost = (Net Weight * Gold Rate) + Cost
        return acc + (netWeight * rate) + cost;
      }, 0);
    },
    goldRate: {
    get() {
      return this.myGoldRate;
    },
    set(value) {
      this.myGoldRate = value;
    }
  }
  },
  watch:{
    goldRate(){
      console.log("MygoldRate=",this.MygoldRate)
      console.log("newrate=",this.goldRate)
    }
  },
  methods: {
    // Bulk lots are stored as Split + isBulk; legacy items fall back to the design's default type.
    itemTypeLabel(item) {
      if (item.isBulk) return "Bulk";
      var type = item.countOrSplit || (item.designId && item.designId.countOrSplit);
      return type || "-";
    },
    // Bulk lots have no per-item weight - show the total lot weight instead
    // (itemPerWeight is always 0 for Bulk; netWeight + stoneWeight is the lot's total weight).
    itemWeightDisplay(item) {
      if (!item.isBulk) return item.itemPerWeight || "-";
      var totalWeight = (item.netWeight || 0) + (item.stoneWeight || 0);
      return totalWeight ? Number(totalWeight).toFixed(2) : "-";
    },
    formatCurrency(num) {
      if (num === null || num === undefined || isNaN(num)) return "0.00";
      return Number(num).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    // Fine Weight = Net Weight * Touch / 100; Cost = Fine Weight * Boarding Rate
    // Cost = Net Weight * (Touch / 100) * (Gold Rate / 100); valued at the live Gold Rate, not the Thankam Rate
    getItemCost(item) {
      var netWeight = parseFloat(item.netWeight) || 0;
      var touch = parseFloat(item.cost) || 0;
      var rate = parseFloat(this.liveGoldRate) || 0;
      return netWeight * (touch / 100) * (rate / 100);
    },
    // Purchase Cost = (Net Weight * Gold Rate) + Cost
    getItemPurchaseCost(item) {
      var netWeight = parseFloat(item.netWeight) || 0;
      var rate = parseFloat(this.liveGoldRate) || 0;
      return (netWeight * rate) + this.getItemCost(item);
    },
    resetForm() {
      this.$refs.myForm.reset();
    },
    showQrTag(id) {
      axios({
        url: "/purchaseitem/qrcode/" + id,
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.qrCodeDataUrl = response.data.qrCodeDataUrl;
            this.qrDialog = true;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    printQrTag() {
      var win = window.open("", "_blank");
      win.document.write(
        '<img src="' + this.qrCodeDataUrl + '" style="width:220px;height:220px" onload="window.print(); window.close();" />'
      );
      win.document.close();
    },
    maxValueRule(value) {
      if (value > 100) {
        return "Maximum value is 100";
      }
      return true;
    },
    setLock() {
     
      if(this.goldRate>0){
        this.isLock = true;
      localStorage.setItem("isLock", this.isLock);
      console.log("lock", this.isLock);
        this.LockItem();
      }
      else{
        this.isLock = false;
        this.msg = "Invalid Thankam Rate";
            this.showsnackbar = true;
      }
    },
    setLockoff() {
      this.isLock = false;
      localStorage.setItem("isLock", this.isLock);
      console.log("lock", this.isLock);
    },
    LockItem() {
      axios({
        url: "/purchase/lock",
        method: "POST",
        data: {
          thankamRate: this.goldRate,
          purchaseId: this.purchaseno,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          // this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            // this. getData();
            // this.finalSubmit();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    
    },
    AutoLockItem() {
      axios({
        url: "/purchase/lock",
        method: "POST",
        data: {
          thankamRate: this.goldRate,
          purchaseId: this.purchaseno,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          // this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            // this. getData();
            this.finalSubmit();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    
    },
  
    checkItem() {
      if (!this.invoiceDate) {
        this.msg = "Please choose invoice date ";
        this.showsnackbar = true;
      } else if (!this.invoicenumber) {
        this.msg = "Please enter invoice number ";
        this.showsnackbar = true;
      }else if (!this.sName) {
        this.msg = "Please choose supplier ";
        this.showsnackbar = true;
      } else if (!this.goldRate) {
        this.msg = "Please enter thankam rate ";
        this.showsnackbar = true;
      } else if (this.goldRate && this.goldRate<=0) {
        this.msg = "Please enter valid thankam rate ";
        this.showsnackbar = true;
      } else if (!this.liveGoldRate || this.liveGoldRate<=0) {
        this.msg = "Live Gold Rate not available. Please add today's Gold Rate in Rate Master.";
        this.showsnackbar = true;
      }  else {
        console.log("inv", this.invoiceDate);
        this.getCategory();
        this.addnewItem = true;
      }
    },
    validate1() {
      if (!this.invoiceDate) {
        this.msg = "Please choose invoice date ";
        this.showsnackbar = true;
      } else if (!this.invoicenumber) {
        this.msg = "Please enter invoice number ";
        this.showsnackbar = true;
      } else if (!this.billDate) {
        this.msg = "Please choose bill date ";
        this.showsnackbar = true;
      } else if (!this.sName) {
        this.msg = "Please choose supplier ";
        this.showsnackbar = true;
      } else if (!this.invoicenumber) {
        this.msg = "Please choose invoice number ";
        this.showsnackbar = true;
      } else if (!this.invoiceDate) {
        this.msg = "Please choose invoice Date ";
        this.showsnackbar = true;
      } else if (!this.goldRate || this.goldRate==0) {
        this.msg = "Please choose thankam rate ";
        this.showsnackbar = true;
      } else if (this.itemz.length>0) {
        this.msg = "Please choose items ";
        this.showsnackbar = true;
      } else {
        this.submit();
        // console.log("suplier==",this.sName)
      }
    },
     validate2() {
      if (!this.invoiceDate) {
        this.msg = "Please choose invoice date ";
        this.showsnackbar = true;
      } else if (!this.billDate) {
        this.msg = "Please choose bill date ";
        this.showsnackbar = true;
      } else if (!this.sName) {
        this.msg = "Please choose supplier ";
        this.showsnackbar = true;
      } else if (!this.invoicenumber) {
        this.msg = "Please choose invoice number ";
        this.showsnackbar = true;
      } else if (!this.invoiceDate) {
        this.msg = "Please choose invoice Date ";
        this.showsnackbar = true;
      } else if (this.itemz.length>0) {
        this.msg = "Please choose items ";
        this.showsnackbar = true;
      } else if (!this.goldRate || this.goldRate==0) {
        this.msg = "Please choose thankam rate ";
        this.showsnackbar = true;
      }
      //  else if (this.isLock==false) {
      //   this.msg = "Please Lock Thankam Rate ";
      //   this.showsnackbar = true;
      // }
      else {
        if(this.isLock==false){
          this.AutoLockItem();
        }
        else{
          this.finalSubmit();
        }
        // this.$router.push('/PurchaseSettlement2?id=' + this.testId)
        // console.log("suplier2==",this.sName)
      }
    },
    changeGST() {
      this.GstStat = "GST";
      console.log("gststst=", this.GstStat);
    },
    changeGST2() {
      this.GstStat = "NOGST";
      console.log("gststst=", this.GstStat);
    },
    cal1() {
      if(this.selectedCountOrSplit == 'Bulk'){
        // Bulk: only the total lot weight is known, no count / per-item weight
        this.purchaseItem.Count = "";
        this.purchaseItem.wt = 0;
        this.purchaseItem.netwt = (this.purchaseItem.totalWt || 0) - (this.purchaseItem.StoneWt || 0);
      }
      else if(this.selectedCountOrSplit == 'Split'){
        // Split: user enters total weight + count, per-item weight is derived
        if(this.purchaseItem.Count>0){
          this.purchaseItem.wt = this.purchaseItem.totalWt / this.purchaseItem.Count;
        } else {
          this.purchaseItem.wt = 0;
        }
        this.purchaseItem.netwt = (this.purchaseItem.totalWt || 0) - (this.purchaseItem.StoneWt || 0);
      }
      else if(this.purchaseItem.Count>0){
        console.log("count>0")
      this.purchaseItem.netwt = (this.purchaseItem.Count * this.purchaseItem.wt) - (this.purchaseItem.StoneWt || 0);
      }
      else{
        console.log("count-else")

      this.purchaseItem.netwt = this.purchaseItem.wt - (this.purchaseItem.StoneWt || 0);
      }
      console.log("purchaseItem.netwt=", this.purchaseItem.netwt);
    },
    cal2() {
      // Cost = Net Weight * (Touch / 100) * (Gold Rate / 100)
      this.tst1 = this.purchaseItem.netwt * (this.purchaseItem.cost / 100) * (this.liveGoldRate / 100);
      this.purchaseItem.MarkingC = this.tst1;
      console.log("tst1", this.tst1);
      // Purchase Cost = (Net Weight * Gold Rate) + Cost
      this.tst3 = (this.purchaseItem.netwt * this.liveGoldRate) + this.purchaseItem.MarkingC;
      console.log("purchaseItem.MarkingC=", this.purchaseItem.MarkingC);
    },
    editcal1() {
      // this.curItem.netWeight=0;
      console.log("curItem.count=",this.curItem.count);
      console.log("curItem.itemPerWeight=",this.curItem.itemPerWeight);

      if(this.curItem.countOrSplit == 'Bulk'){
        // Bulk: only the total lot weight is known, no count / per-item weight
        this.curItem.count = 0;
        this.curItem.itemPerWeight = 0;
        this.curItem.netWeight = (this.curItem.totalWeight || 0) - (this.curItem.stoneWeight || 0);
      }
      else if(this.curItem.countOrSplit == 'Split'){
        // Split: user enters total weight + count, per-item weight is derived
        if(this.curItem.count>0){
          this.curItem.itemPerWeight = this.curItem.totalWeight / this.curItem.count;
        } else {
          this.curItem.itemPerWeight = 0;
        }
        this.curItem.netWeight = (this.curItem.totalWeight || 0) - (this.curItem.stoneWeight || 0);
      }
      else if(this.curItem.count){
      this.curItem.netWeight = (this.curItem.count * this.curItem.itemPerWeight) - (this.curItem.stoneWeight || 0);
      console.log("if-curItem.netWeight=",this.curItem.netWeight);

      }
      else{
      this.curItem.netWeight = (this.curItem.itemPerWeight*1) - (this.curItem.stoneWeight || 0);
      console.log("else-curItem.netWeight=",this.curItem.netWeight);

      }
      this.editcal2();
    },
    editcal2() {
      // Cost = Net Weight * (Touch / 100) * (Gold Rate / 100)
      this.tst1 = this.curItem.netWeight * (this.curItem.cost / 100) * (this.liveGoldRate / 100);
      this.curItem.makingCharge = this.tst1;
      console.log("tst1", this.tst1);
      console.log("curItem.makingCharge", this.curItem.makingCharge);
      // Purchase Cost = (Net Weight * Gold Rate) + Cost
      this.tst3 = (this.curItem.netWeight * this.liveGoldRate) + this.curItem.makingCharge;
      console.log("tst3=", this.tst3);
    },
checktype(ID){
  console.log("ID=",ID)
  var singleobj =this.designList.find((x)=> x._id == ID);
  if(singleobj){
    // Default from the design's setting, but the user can still override
    // it per purchase transaction via onCountOrSplitChange().
    this.selectedCountOrSplit = singleobj.countOrSplit;
    this.dtype = true;
    console.log("singleobj.countOrSplit==", singleobj.countOrSplit);
  }
},
// HUID is issued by BIS and marked on the piece; we only tidy and check it.
cleanHUID(val){
  var cleaned = (val || "").replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 6);
  return cleaned || null;
},
huidRule(val){
  if(!val) return true;
  return /^[A-Z0-9]{6}$/.test(val) || "HUID must be 6 letters/digits (e.g. AB12C3)";
},
huidAllowed(mode, count){
  return mode == 'Count' && parseFloat(count) === 1;
},
entryModeHint(mode){
  if(mode == 'Count') return "Pieces of the same weight — enter count and weight of one piece.";
  if(mode == 'Split') return "Enter total weight and count — per-piece weight is worked out for you.";
  if(mode == 'Bulk') return "Loose lot bought by weight — enter only the total lot weight. Stocked and sold by weight.";
  return "Choose how this item is being purchased.";
},
setEntryMode(mode){
  if(this.selectedCountOrSplit == mode) return;
  this.selectedCountOrSplit = mode;
  this.onCountOrSplitChange();
},
setEditEntryMode(mode){
  if(this.curItem.countOrSplit == mode) return;
  this.$set(this.curItem, "countOrSplit", mode);
  this.onEditCountOrSplitChange();
},
onHUIDsChange(list){
  var seen = [];
  var bad = [];
  (list || []).forEach((raw) => {
    var h = this.cleanHUID(raw);
    if(!h) return;
    if(this.huidRule(h) !== true){ bad.push(h); return; }
    if(!seen.includes(h)) seen.push(h);
  });
  this.purchaseItem.HUIDs = seen;
  if(bad.length){
    this.msg = "Skipped invalid HUID " + bad.join(", ") + " - it must be 6 letters/digits";
    this.showsnackbar = true;
  }
},
onCountOrSplitChange(){
  this.purchaseItem.HUIDs = [];
  this.purchaseItem.Count = "";
  this.purchaseItem.wt = 0;
  this.purchaseItem.totalWt = 0;
  this.purchaseItem.netwt = 0;
  this.cal1();
},
checktype2(item){
  if(item && item.designId){
    this.dtype2 = true;
    // Legacy purchase items saved before countOrSplit lived on the item
    // itself fall back to the design's default until edited and saved.
    if(!item.countOrSplit){
      item.countOrSplit = item.designId.countOrSplit;
    }
    // Bulk lots are stored as Split + isBulk; show them in Bulk mode.
    if(item.isBulk){
      item.countOrSplit = 'Bulk';
    }
    // Split items only persist netWeight/itemPerWeight; reconstruct the
    // total weight that was originally split across the count.
    if((item.countOrSplit == 'Split' || item.countOrSplit == 'Bulk') && !item.totalWeight){
      item.totalWeight = (item.netWeight || 0) + (item.stoneWeight || 0);
    }
  }
},
onEditCountOrSplitChange(){
  this.curItem.count = 0;
  this.curItem.itemPerWeight = 0;
  this.curItem.totalWeight = 0;
  this.curItem.netWeight = 0;
  this.editcal1();
},
    choosetype() {
      console.log(this.paymentTypes, "array");
      if (this.paymentTypes.includes("Thankam")) {
        this.checkvalue = true;
      } else {
        this.checkvalue = false;
      }
    },
    editCheck(){
      if(this.curItem.countOrSplit == 'Bulk' && (!this.curItem.totalWeight || this.curItem.totalWeight <= 0)){
        this.msg = "Please enter total lot weight ";
        this.showsnackbar = true;
      }
      else if(this.curItem.countOrSplit == 'Bulk' && this.curItem.netWeight <= 0){
        this.msg = "Stone weight cannot exceed total lot weight ";
        this.showsnackbar = true;
      }
      else if(this.curItem.countOrSplit != 'Bulk' && (!this.curItem.itemPerWeight || this.curItem.itemPerWeight <= 0)){
        this.msg = "Please enter valid item/weight ";
        this.showsnackbar = true;
      }
      else if(this.curItem.HUID && this.huidRule(this.curItem.HUID) !== true){
        this.msg = this.huidRule(this.curItem.HUID);
        this.showsnackbar = true;
      }
      else if(!['Count', 'Split', 'Bulk'].includes(this.curItem.countOrSplit)){
        this.msg = "Please choose Count or Split ";
        this.showsnackbar = true;
      }
      else{
        this.editItem();
      }
    },
    editItem() {
      axios({
        url: "/purchaseitem/edit",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.curItem._id,
          //     categoryId : this.curItem.designId.categoryId,
          // itemId : this.curItem.value.designId.itemId,
          // designId : this.curItem.designId.name,
          // designName : this.returndata.designName,
          thankamRate:this.goldRate,
          // Bulk is persisted as a weight-only Split item flagged isBulk
          countOrSplit: this.curItem.countOrSplit == 'Bulk' ? 'Split' : this.curItem.countOrSplit,
          isBulk: this.curItem.countOrSplit == 'Bulk',
          count: this.curItem.count,
          itemPerWeight: this.curItem.itemPerWeight,
          cost: this.curItem.cost,
          // totalAmount: this.tst3,
          netWeight: this.curItem.netWeight,
          // makingCharge: this.curItem.makingCharge,
          stonePrice: this.curItem.stonePrice,
          stoneWeight: this.curItem.stoneWeight,
          huid: this.curItem.HUID,
          metalType: this.curItem.metalType,
          karat: this.curItem.karat,
        },
      })
        .then((response) => {
          this.editdialogue = false;
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteStaff() { 
      axios({
        url: "/purchaseitem/delete",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.curId,
        },
      })
        .then((response) => {
          this.dialoge = false;
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    //  validateInput() {
    //   if (!this.email) {
    //     this.msg = "Please provide email";
    //     this.showsnackbar = true;
    //     return;
    //   } else if (!this.name) {
    //     this.msg = "Please provide name";
    //     this.showsnackbar = true;
    //     return;
    //   } else if (!this.phone) {
    //     this.msg = "Please provide phone";
    //     this.showsnackbar = true;
    //     return;
    //   } else if (!this.username) {
    //     this.msg = "Please provide username";
    //     this.showsnackbar = true;
    //     return;
    //   }  else if (!this.address) {
    //     this.msg = "Please provide address";
    //     this.showsnackbar = true;
    //     return;
    //   }  else {
    //     this.addAdmin();
    //   }
    // },

    getBill() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/purchase/bill/generate",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        // params: {
        //   page: this.page,
        //   count: 20,
        // },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.Details = response.data;
            this.bill = response.data.bill;
            this.invoicenumber = response.data.invoice;
            console.log("billno=", this.bill);
            this.getData();
            this.Pagelength = Math.ceil(response.data.count / 20);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    isCurrentVariantEmpty() {
      // entry mode is kept between variants, so it doesn't count as input
      return !this.purchaseItem.Count && !this.purchaseItem.wt
        && !this.purchaseItem.totalWt && !this.purchaseItem.cost && !this.purchaseItem.StPrice
        && !this.purchaseItem.StoneWt && !(this.purchaseItem.HUIDs || []).length;
    },
    valid(saveNow){
      // Already-queued variants + nothing new typed in: just submit what's queued.
      if (saveNow && this.variantPreview.length > 0 && this.isCurrentVariantEmpty()) {
        this.submitPurchaseItems();
        return;
      }
      if (!this.purchaseItem.test) {
        this.msg = "Please choose category ";
        this.showsnackbar = true;
      } else if (!this.purchaseItem.test2) {
        this.msg = "Please choose item ";
        this.showsnackbar = true;
      } 
      else if (!this.purchaseItem.design) {
        this.msg = "Please choose design ";
        this.showsnackbar = true;
      }
      else if (!['Count', 'Split', 'Bulk'].includes(this.selectedCountOrSplit)) {
        this.msg = "Please choose Count, Split or Bulk ";
        this.showsnackbar = true;
      }
      else if (this.selectedCountOrSplit == 'Bulk' && !this.purchaseItem.totalWt) {
        this.msg = "Please enter total lot weight ";
        this.showsnackbar = true;
      }
      else if (this.selectedCountOrSplit == 'Bulk' && this.purchaseItem.netwt <= 0) {
        this.msg = "Stone weight cannot exceed total lot weight ";
        this.showsnackbar = true;
      }
       else if (this.selectedCountOrSplit != 'Bulk' && !this.purchaseItem.Count) {
        this.msg = "Please enter Count ";
        this.showsnackbar = true;
      } else if (this.selectedCountOrSplit == 'Split' && !this.purchaseItem.totalWt) {
        this.msg = "Please enter total weight ";
        this.showsnackbar = true;
      } else if (this.selectedCountOrSplit != 'Bulk' && !this.purchaseItem.wt) {
        this.msg = "Please enter item/weight ";
        this.showsnackbar = true;
      }  else if (this.purchaseItem.StPrice && !this.purchaseItem.StoneWt) {
        // if (!this.purchaseItem.StoneWt) {
        this.msg = "Please enter stone weight ";
        this.showsnackbar = true;
        // }
      }  else if (this.purchaseItem.StoneWt && !this.purchaseItem.StPrice) {
        // if (!this.purchaseItem.StPrice) {
        this.msg = "Please enter stone price ";
        this.showsnackbar = true;
        // }
      } else if ((this.purchaseItem.HUIDs || []).length && this.selectedCountOrSplit != 'Count') {
        this.msg = "HUIDs are entered on Count pieces";
        this.showsnackbar = true;
      } else if ((this.purchaseItem.HUIDs || []).length > parseFloat(this.purchaseItem.Count)) {
        this.msg = this.purchaseItem.HUIDs.length + " HUIDs entered for " + this.purchaseItem.Count + " pieces - one HUID per piece";
        this.showsnackbar = true;
      } else if (this.queuedHUIDClash()) {
        this.msg = "HUID " + this.queuedHUIDClash() + " is already added in this purchase";
        this.showsnackbar = true;
      }else if (!this.purchaseItem.cost) {
        this.msg = "Please enter cost ";
        this.showsnackbar = true;
      } else if (this.purchaseItem.cost>100) {
        this.msg = "Please enter valid seller cost ";
        this.showsnackbar = true;
      } else if (!this.purchaseItem.netwt) {
        this.msg = "Please enter net weight ";
        this.showsnackbar = true;
      } else {

        this.addValues(saveNow);
      }
    },
    addValues(saveNow) {
      this.singleitem.categoryId = this.purchaseItem.test;
      this.singleitem.itemId = this.purchaseItem.test2;
      this.singleitem.designId = this.purchaseItem.design;
      // this.singleitem.designName = this.returndata.designName;
      // Bulk is persisted as a weight-only Split item flagged isBulk
      var isBulk = this.selectedCountOrSplit == 'Bulk';
      this.singleitem.countOrSplit = isBulk ? 'Split' : this.selectedCountOrSplit;
      this.singleitem.isBulk = isBulk;
      this.singleitem.count = isBulk ? 0 : this.purchaseItem.Count;
      this.singleitem.itemPerWeight = isBulk ? 0 : this.purchaseItem.wt;
      this.singleitem.cost = this.purchaseItem.cost;
      // this.singleitem.totalAmount = this.tst3;
      this.singleitem.netWeight = this.purchaseItem.netwt;
      // this.singleitem.makingCharge = this.purchaseItem.MarkingC;
      this.singleitem.stonePrice = this.purchaseItem.StPrice;
      this.singleitem.stoneWeight = this.purchaseItem.StoneWt;
      this.singleitem.HUID = null;

      var huids = isBulk ? [] : (this.purchaseItem.HUIDs || []);
      if (huids.length == 0) {
        this.addVariant(saveNow);
        return;
      }
      // Each HUID is one physical piece, so every hallmarked piece becomes its
      // own count-1 stock item; any pieces left without a HUID stay as one lot.
      // Stone weight/price are shared out per piece, with rounding left on the
      // last entry so the totals still match what was typed in.
      var lot = JSON.parse(JSON.stringify(this.singleitem));
      var pieces = parseFloat(lot.count) || 0;
      var perWt = parseFloat(lot.itemPerWeight) || 0;
      var totalStoneWt = parseFloat(lot.stoneWeight) || 0;
      var totalStonePrice = parseFloat(lot.stonePrice) || 0;
      var stoneWtEach = Math.round((totalStoneWt / pieces) * 1000) / 1000;
      var stonePriceEach = Math.round((totalStonePrice / pieces) * 100) / 100;
      var parts = huids.map((h) => ({ count: 1, HUID: h, stoneWeight: stoneWtEach, stonePrice: stonePriceEach }));
      var rest = pieces - huids.length;
      if (rest > 0) {
        parts.push({ count: rest, HUID: null, stoneWeight: stoneWtEach * rest, stonePrice: stonePriceEach * rest });
      }
      var usedStoneWt = parts.reduce((a, x) => a + x.stoneWeight, 0);
      var usedStonePrice = parts.reduce((a, x) => a + x.stonePrice, 0);
      var last = parts[parts.length - 1];
      last.stoneWeight += totalStoneWt - usedStoneWt;
      last.stonePrice += totalStonePrice - usedStonePrice;
      parts.forEach((part, idx) => {
        this.singleitem = Object.assign(JSON.parse(JSON.stringify(lot)), {
          count: part.count,
          HUID: part.HUID,
          stoneWeight: Math.round(part.stoneWeight * 1000) / 1000,
          stonePrice: Math.round(part.stonePrice * 100) / 100,
          netWeight: Math.round((perWt * part.count - part.stoneWeight) * 1000) / 1000,
        });
        // only the final part saves / resets the form
        this.addVariant(idx == parts.length - 1 ? saveNow : null);
      });
    },
    queuedHUIDClash() {
      var queued = this.itemz.map((x) => x.HUID).filter(Boolean);
      return (this.purchaseItem.HUIDs || []).find((h) => queued.includes(h)) || null;
    },
    // addVariant() {
    //   this.itemz.push(JSON.parse(JSON.stringify(this.singleitem)));
    //   console.log("itemz=", this.itemz);
    //   (this.purchaseItem.test = null),
    //     (this.purchaseItem.test2 = null),
    //     (this.purchaseItem.design = null);
    //   this.purchaseItem.Count = null;
    //   this.purchaseItem.netwt = null;
    //   this.purchaseItem.wt = null;
    //   this.purchaseItem.MarkingC = null;
    //   this.purchaseItem.StPrice = null;
    //   this.purchaseItem.StoneWt = null;
    //   this.purchaseItem.totalamt = null;
    //   this.check = false;
    //   this.returndata = [];
    // },
    addVariant(saveNow) {
      // Display-friendly copy so the modal can list queued variants; the
      // actual payload copy goes into itemz.
      this.variantPreview.push({
        categoryName: (this.categoryList.find((c) => c._id == this.purchaseItem.test) || {}).name,
        itemName: (this.ItemList.find((i) => i._id == this.purchaseItem.test2) || {}).name,
        designName: (this.designList.find((d) => d._id == this.purchaseItem.design) || {}).name,
        countOrSplit: this.singleitem.countOrSplit,
        isBulk: this.singleitem.isBulk,
        count: this.singleitem.count,
        itemPerWeight: this.singleitem.itemPerWeight,
        netWeight: this.singleitem.netWeight,
        cost: this.singleitem.cost,
        HUID: this.singleitem.HUID,
      });
      this.itemz.push(JSON.parse(JSON.stringify(this.singleitem)));
      console.log("itemz=", this.itemz);
      if (saveNow === null) {
        // more hallmarked pieces of the same entry still to queue
        return;
      }

      // Reset only the weight/count fields so Category/Item/Design stay
      // selected, ready for entering the next variant of the same design.
      this.purchaseItem.Count = 0;
      this.purchaseItem.netwt = 0;
      this.purchaseItem.wt = 0;
      this.purchaseItem.totalWt = 0;
      this.purchaseItem.cost = 0;
      this.purchaseItem.StPrice = 0;
      this.purchaseItem.StoneWt = 0;
      this.purchaseItem.HUID = null;
      this.purchaseItem.HUIDs = [];
      // Keep the entry mode so the next variant of the same design is quick to enter.

      if (!saveNow) {
        this.msg = "Variant added. Add another or click Add to Purchase to save.";
        this.showsnackbar = true;
        return;
      }

      this.submitPurchaseItems();
    },
    submitPurchaseItems() {
      (this.purchaseItem.test = null),
        (this.purchaseItem.test2 = null),
        (this.purchaseItem.design = null);
      this.check = false;
      this.returndata = [];
      this.dtype = false;
      axios({
        url: "/pendingitem/add",
        method: "POST",
        data: {
          thankamRate: this.goldRate,
          isLock: this.isLock,
          items: this.itemz,
          billNo: this.Details.bill,
          billPrefix: this.billPrefix,
          date: this.billDate,
          supplierId: this.sName,
          // invoiceNo: this.Details.invoice,
          invoiceNo: this.invoicenumber,
          invoiceDate: this.invoiceDate,
          // taxType: this.GstStat,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.addnewItem = false;
            this.itemz = [];
            this.variantPreview = [];
            this.purchaseno = response.data.purchaseId;
            console.log("purnum=", this.purchaseno);
            this.getData();
          } else {
            this.itemz = [];
            this.variantPreview = [];
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    removeVariant(index) {
      this.itemz.splice(index, 1);
      this.variantPreview.splice(index, 1);
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/purchase/item/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          billNo: this.bill,
          purchaseId: this.purchaseno,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.savedList = response.data.data;
            if (response.data.purchasedata && response.data.purchasedata.billPrefix) {
              this.billPrefix = response.data.purchasedata.billPrefix;
            }
            this.totalCostWithGst = response.data.purchasedata.totalCostWithGst;
            this.sName = response.data.purchasedata.supplierId._id;
            console.log("sName=====",this.sName)
            this.taxType = response.data.purchasedata.taxType;
            if(response.data.purchasedata.isLock==true){
            this.isLock = true;
            }
            this.goldRate=response.data.purchasedata.thankamRate
            this.invoiceDate = response.data.purchasedata.invoiceDate;
            this.invoiceDate1 = response.data.purchasedata.invoiceDate;
            this.invoiceDate1 = this.formatDate(this.invoiceDate1);
            console.log("invoiceDate1=", this.invoiceDate1);
            this.invoiceDate = this.invoiceDate1;
            this.testId = response.data.purchasedata._id;
            console.log("purchaseid=", this.testId);
            this.totalMakingCharge =
              response.data.purchasedata.totalMakingCharge;
            this.totalnetweight = response.data.purchasedata.totalNetWeight;
            this.finalTotal = response.data.purchasedata.totalPurchaseCost;
            this.purchaseno = response.data.purchasedata._id;
            // this.Pagelength = Math.ceil(response.data.count / 20);
          } else {
            // this.snackbar = true;
            // this.msg = response.data.msg;
            this.savedList=[];
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getCategory() {
      // this.appLoading = true;
      this.purchaseItem.test2="";
      this.purchaseItem.design="";
      axios({
        method: "get",
        url: "/category/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        // params: {
        //   page: this.page,
        //   count: 20,
        // },
      })
        .then((response) => {
          // this.appLoading = false;
          if (response.data.status == true) {
            this.categoryList = response.data.data;
            this.purchaseItem.test2="";
      this.purchaseItem.design="";
            this.Pagelength = Math.ceil(response.data.count / 20);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getItem() {
      // this.appLoading = true;
      this.purchaseItem.design="";
      axios({
        method: "get",
        url: "/item/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          categoryId: this.purchaseItem.test,
          // page: this.page,
          // count: 20,
        },
      })
        .then((response) => {
          // this.appLoading = false;
          if (response.data.status == true) {
            this.ItemList = response.data.data;
            this.Pagelength = Math.ceil(response.data.count / 20);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getDesign() {
      // this.appLoading = true;
      axios({
        method: "get",
        url: "/design/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          itemId: this.purchaseItem.test2,
          // page: this.page,
          // count: 20,
        },
      })
        .then((response) => {
          // this.appLoading = false;
          if (response.data.status == true) {
            this.designList = response.data.data;
            this.Pagelength = Math.ceil(response.data.count / 20);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getBording() {
    console.log("7");
      this.appLoading = true;
      axios({
        url: "/rate/view",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          date: this.billDate,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.liveGoldRate = parseFloat(response.data.data.goldRate) || 0;
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getHSN() {
      this.appLoading = true;
      axios({
        url: "/hsnCodes/list",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.currentPage,
          limit: 50,
          searchKeyword: "",
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.CodeList = response.data.data;
          this.pages = Math.ceil(response.data.totalLength / 50);
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getSupplier() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/supplier/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        // params: {
        //   page: this.page,
        //   count: 20,
        // },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.supplierList = response.data.data;
            this.Pagelength = Math.ceil(response.data.count / 20);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    AddItem() {
      axios({
        url: "/individual/itemcalculation",
        method: "POST",
        data: {
          // taxType: this.GstStat,
          designId: this.purchaseItem.design,
          count: this.purchaseItem.Count,
          netWeight: this.purchaseItem.netwt,
          itemPerWeight: this.purchaseItem.wt,
          cost: this.purchaseItem.MarkingC,
          stonePrice: this.purchaseItem.StPrice,
          stoneWeight: this.purchaseItem.StoneWt,
          boardingRate: this.purchaseItem.Br,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;

            this.check = true;
            console.log("check=", this.check);
            this.returndata = response.data;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    submit() {
      axios({
        method: "post",
        url: "/purchase/settle/later",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          thankamRate: this.goldRate,
          billNo: this.Details.bill,
          billPrefix: this.billPrefix,
          purchaseDate: this.billDate,
          supplierId: this.sName,
          invoiceNo: this.invoicenumber,
          // items: this.itemz,
          purchaseId: this.testId,
          invoiceDate: this.invoiceDate,
          isLock: this.isLock,
        },
      })
        .then((response) => {
          if (response.data.status) {
            // this.uploadId = response.data.bill._id;
            // if (this.bills.length > 0) this.uploadBills(this.uploadId);
            this.msg = response.data.msg;
            this.showsnackbar = true;
            // location.reload();
            this.$router.push('/PurchaseList');
            // this.totalMakingCharge = response.data.totalMakingCharge;
            // this.totalPurchaseCost = response.data.totalPurchaseCost;
            // this.purchaseId = response.data._id;
            // this.getBill();
            // this.getData();
            // this.Details.bill = null;
            // this.billNo = null;
            // this.billDate = null;
            // this.sName = null;
            // this.Details.invoice = null;
            // this.invoiceDate = null;
            // this.itemz = [];
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    finalSubmit() {
      axios({
        method: "post",
        // url: "/purchase/payment",
        url: "/purchase/generate/bill",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          billNo: this.Details.bill,
          billPrefix: this.billPrefix,
          purchaseDate: this.billDate,
          supplierId: this.sName,
          invoiceNo: this.invoicenumber,
          invoiceDate: this.invoiceDate,

          purchaseId: this.purchaseno,
          isLock: this.isLock,
          thankamRate: this.goldRate,
          // paymentType: this.paymentTypes,
          // payAmount: this.finalTotal,
          // thankamDetails: this.thankamDetails,
        },
      })
        .then((response) => {
          if (response.data.status) {
            // this.uploadId = response.data.bill._id;
            // if (this.bills.length > 0) this.uploadBills(this.uploadId);
            this.msg = response.data.msg;
            this.showsnackbar = true;
            // this.$router.push("/PurchaseList");
            // this.$router.go(-1);
            // this.totalMakingCharge = response.data.totalMakingCharge;
            // this.totalPurchaseCost = response.data.totalPurchaseCost;
            // this.purchaseId = response.data.id;
            // this.Details.bill = null;
            // this.billNo = null;
            // this.billDate = null;
            // this.sName = null;
            // this.Details.invoice = null;
            // this.invoiceDate = null;
            // this.itemz = [];
            setTimeout(() => {
              const prefixParam = this.billPrefix ? '&prefix=' + encodeURIComponent(this.billPrefix) : '';
              const billNoParam = (this.Details && this.Details.bill) ? '&billno=' + encodeURIComponent(this.Details.bill) : '';
              this.$router.push('/IssueReceipt?purchaseId=' + this.testId + prefixParam + billNoParam);
            }, 1000);
        // this.$router.push('/PurchaseSettlement2?id=' + this.testId)

          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    userinfo() {
      axios({
      method: "GET",
      url: "/user/info",
      headers: {
        "x-auth-token": localStorage.getItem("token"),
      },
      params:{
        id:localStorage.getItem("id")
      }
    })
      .then((response) => {
        // console.log("menu-loginpage");
        if (response.data.status) {
        var check = response.data.goldrateadded;
            if (check == false) {
              console.log("check===-=", check);
              this.queryPopUpDialog = true;
            }
        }
        else{
          console.log("estpage user info")
          return;
        }
      })
      .catch((err) => {
        var msg = err;
        console.log(msg);
      });
    },
    EditRate() {
      axios({
        url: "/rate/add",
        method: "POST",
        data: {
          goldRate: this.gold,
          silverRate: this.silverRate,
          platinumRate: this.platinumRate,
          diamond: this.diamond,
          date: this.date,
          thankamRate: this.thankamRate,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.queryPopUpDialog = false;
            
            localStorage.setItem("diamond", response.data.data.diamond);
          localStorage.setItem("goldRate", response.data.data.goldRate);
          localStorage.setItem("platinumRate", response.data.data.platinumRate);
          localStorage.setItem("silverRate", response.data.data.silverRate);
          localStorage.setItem("thankamRate", response.data.data.thankamRate);
            location.reload();
            // this.goldrate = null;
            // this.silverrate = null;
            // this.platinumrate = null;
            // this.diamondrate = null;
            this.date = null;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getCategoryDotClass(name) {
      if (!name) return 'dot-default';
      var n = String(name).toLowerCase();
      if (n.includes('gold') || n.includes('thankam')) return 'dot-gold';
      if (n.includes('platinum')) return 'dot-platinum';
      if (n.includes('silver')) return 'dot-silver';
      if (n.includes('diamond')) return 'dot-diamond';
      return 'dot-default';
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      // var hours = dt.getHours();
      // var minutes = dt.getMinutes();
      dt = dt.toString();
      // var ampm = hours >= 12 ? "pm" : "am";
      // hours = hours % 12;
      // hours = hours ? hours : 12;
      // minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = day + " " + dt.slice(4, 7) + " " + year;
      //  +
      // " , " +
      // hours +
      // ":" +
      // minutes +
      // " " +
      // ampm;

      return strTime;
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&family=Inter:wght@400;500;600&display=swap");

.boarding-dialog-card {
  background: #ffffff !important;
  font-family: "Plus Jakarta Sans", "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  padding: 24px;
}

.boarding-dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.boarding-header-icon {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.boarding-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 0.3px;
}

.boarding-subtitle {
  font-size: 12px;
  color: #64748b;
  margin-top: 1px;
}

.boarding-rate-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

.boarding-rate-card-full {
  grid-column: 1 / -1;
}

.boarding-rate-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
  transition: all 0.2s ease;
}

.boarding-rate-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.boarding-rate-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.boarding-rate-img-pill {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background-color: #ffffff;
  border: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.boarding-rate-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.boarding-rate-label {
  font-size: 13px;
  font-weight: 700;
  color: #334155;
  letter-spacing: 0.2px;
}

.boarding-rate-label span {
  font-weight: 500;
  color: #94a3b8;
  font-size: 11px;
  margin-left: 2px;
}

.boarding-rate-input :deep(.v-input__slot) {
  border-radius: 8px !important;
  font-size: 20px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
}

.boarding-rate-input :deep(fieldset) {
  border-color: #e2e8f0 !important;
}

.boarding-rate-input.v-input--is-focused :deep(fieldset) {
  border-color: #9a6b27 !important;
  border-width: 1.5px !important;
}

.boarding-rate-input :deep(input) {
  font-size: 20px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
}

.boarding-rate-input :deep(.v-text-field__prefix) {
  font-size: 18px !important;
  font-weight: 700 !important;
  color: #64748b !important;
}

.boarding-dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.boarding-save-btn {
  background: linear-gradient(135deg, #b9893f 0%, #875c24 100%) !important;
  background-color: #9a6b27 !important;
  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  height: 42px !important;
  padding: 0 22px !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 14px rgba(154, 106, 44, 0.28) !important;
  transition: all 0.2s ease !important;
}

.boarding-save-btn:hover {
  background: linear-gradient(135deg, #c59449 0%, #956627 100%) !important;
  box-shadow: 0 6px 18px rgba(154, 106, 44, 0.38) !important;
  transform: translateY(-1.5px);
}

@media (max-width: 600px) {
  .boarding-rate-grid {
    grid-template-columns: 1fr;
  }
  .boarding-rate-card-full {
    grid-column: auto;
  }
}

.purchase-entry-page {
  font-family: "Plus Jakarta Sans", "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  color: #1e293b;
  text-align: left !important;
  padding-bottom: 32px;
}

.purchase-entry-page * {
  text-align: left;
}

.purchase-entry-page .text-center,
.purchase-entry-page .text-center * {
  text-align: center !important;
}

.purchase-entry-page .text-right,
.purchase-entry-page .text-right * {
  text-align: right !important;
}

/* Page Header */
.page-header-container {
  padding: 0 2px;
}

.back-btn {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  transition: all 0.2s ease;
}

.back-btn:hover {
  background-color: #fff7ed;
  border-color: #fed7aa;
  transform: translateX(-2px);
}

.page-title {
  font-size: 21px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
  line-height: 1.3;
  letter-spacing: -0.2px;
}

.page-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 3px;
  font-weight: 400;
}

.bill-badge {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  padding: 2px 8px;
  border-radius: 6px;
}

.breadcrumbs-sub {
  font-size: 12px;
}

.breadcrumb-link {
  color: #64748b;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

.breadcrumb-link:hover {
  color: #9a6b27;
}

.breadcrumb-current {
  font-weight: 600;
  color: #0f172a;
}

/* Status Badges */
.status-pill {
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 9999px;
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1.4;
  gap: 5px;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}

.status-draft {
  background-color: #fffbeb;
  color: #92400e;
  border: 1px solid #fde68a;
}

.dot-draft {
  background-color: #f59e0b;
}

/* Buttons */
.btn-compact {
  height: 38px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  letter-spacing: 0.1px !important;
  padding: 0 16px !important;
  border-radius: 8px !important;
  text-transform: none !important;
}

.primary-action-btn {
  background: linear-gradient(135deg, #b9893f 0%, #875c24 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 14px rgba(154, 106, 44, 0.28) !important;
  transition: all 0.2s ease !important;
  border-radius: 10px !important;
}

.primary-action-btn:hover {
  background: linear-gradient(135deg, #c59449 0%, #956627 100%) !important;
  box-shadow: 0 6px 18px rgba(154, 106, 44, 0.38) !important;
  transform: translateY(-1px);
}

.action-outline-btn {
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff !important;
  color: #334151 !important;
  transition: all 0.2s ease !important;
}

.action-outline-btn .action-btn-icon {
  color: #64748b !important;
  transition: color 0.2s ease;
}

.action-outline-btn:hover {
  border-color: #9a6b27 !important;
  color: #9a6b27 !important;
  background-color: #fffaf5 !important;
  transform: translateY(-1px);
}

.action-outline-btn:hover .action-btn-icon {
  color: #9a6b27 !important;
}

.submit-outline-btn {
  height: 40px !important;
  padding: 0 18px !important;
  font-size: 13px !important;
}

.submit-primary-btn {
  height: 40px !important;
  padding: 0 22px !important;
  font-size: 13px !important;
}

/* Section Cards (Airy, clean white, no heavy colored headers) */
.section-card {
  background-color: #ffffff;
  border: 1px solid #eef2f6;
  border-radius: 14px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02), 0 4px 12px rgba(0, 0, 0, 0.02) !important;
  overflow: hidden;
}

.section-header {
  background-color: #ffffff;
  border-bottom: 1px solid #f1f5f9;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
  line-height: 1.3;
}

.section-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 3px;
  font-weight: 400;
}

.entry-mode-toggle {
  display: inline-flex;
  width: 100%;
  border: 1px solid #e2d6bf;
  border-radius: 8px;
  padding: 3px;
  background: #faf7f0;
  gap: 3px;
}
.entry-mode-option {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 7px 10px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  background: transparent;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.entry-mode-option .v-icon {
  color: inherit !important;
}
.entry-mode-option:hover {
  color: #9a6b27;
}
.entry-mode-option.active {
  background: #ffffff;
  color: #9a6b27;
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(154, 107, 39, 0.18);
}
.entry-mode-hint {
  margin-top: 6px;
  font-size: 12px;
  color: #8a7a60;
}
.huid-counter {
  margin-left: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #9a6b27;
}
.huid-field >>> .v-chip {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  letter-spacing: 0.08em;
  background: #f5ecdc !important;
  color: #7a531c;
}
.huid-field >>> input {
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}
.bulk-pill {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  color: #9a6b27;
  background: #f5ecdc;
}
.type-pill {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.2px;
}
.type-pill--count {
  color: #1d4ed8;
  background: #e8f0fe;
}
.type-pill--split {
  color: #15803d;
  background: #e5f6ec;
}
.type-pill--bulk {
  color: #9a6b27;
  background: #f5ecdc;
}
.type-pill--- {
  color: #64748b;
  background: #f1f5f9;
}
.count-badge {
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #475569;
  font-size: 11.5px;
  font-weight: 600;
  padding: 2px 9px;
  border-radius: 12px;
}

/* Form Styles */
.form-label-elegant {
  display: block;
  font-size: 12.5px;
  font-weight: 500;
  color: #334151;
  letter-spacing: 0;
  text-transform: none;
  margin-bottom: 6px;
}

.custom-field >>> .v-input__control,
.custom-field >>> .v-input__slot {
  border-radius: 8px !important;
  font-size: 13.5px !important;
  min-height: 42px !important;
  height: 42px !important;
  border-color: #e2e8f0 !important;
  background-color: #ffffff !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02) !important;
  transition: all 0.15s ease !important;
}

.custom-field >>> .v-input__slot:hover {
  border-color: #cbd5e1 !important;
}

.custom-field.v-input--is-focused >>> .v-input__slot {
  border-color: #9a6b27 !important;
  box-shadow: 0 0 0 3px rgba(184, 106, 36, 0.1) !important;
}

.custom-field >>> input {
  font-size: 13.5px !important;
  color: #0f172a !important;
  font-weight: 500 !important;
}

.custom-field >>> input::placeholder {
  color: #94a3b8 !important;
  font-weight: 400 !important;
  font-size: 13px !important;
}

.custom-field >>> .v-input__prepend-inner {
  margin-top: 9px !important;
  margin-right: 6px !important;
}

/* Select & Dropdown Field Customizations */
.custom-select-field >>> .v-select__selections {
  min-height: 40px !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 !important;
}

.custom-select-field >>> .v-select__selection--comma,
.dropdown-selection-text {
  font-size: 13.5px !important;
  font-weight: 500 !important;
  color: #0f172a !important;
  margin: 0 !important;
  text-align: left !important;
}

.custom-select-field >>> .v-input__append-inner {
  margin-top: 9px !important;
  padding-right: 4px;
}

.custom-select-field >>> .v-input__append-inner .v-icon {
  font-size: 20px !important;
  color: #94a3b8 !important;
  transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1), color 0.15s ease !important;
}

.custom-select-field.v-input--is-focused >>> .v-input__append-inner .v-icon,
.custom-select-field.v-select--is-menu-active >>> .v-input__append-inner .v-icon {
  color: #9a6b27 !important;
  transform: rotate(180deg) !important;
}

/* Custom dropdown items inside options */
.dropdown-custom-item {
  width: 100%;
  font-family: "Plus Jakarta Sans", "Inter", sans-serif;
  text-align: left;
}

.dropdown-icon-pill {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dropdown-item-title {
  font-size: 13.5px;
  font-weight: 500;
  color: #1e293b;
  text-align: left;
}

.category-color-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.8), 0 1px 3px rgba(0, 0, 0, 0.15);
}

.dot-gold {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}

.dot-platinum {
  background: linear-gradient(135deg, #94a3b8, #475569);
}

.dot-silver {
  background: linear-gradient(135deg, #cbd5e1, #64748b);
}

.dot-diamond {
  background: linear-gradient(135deg, #38bdf8, #0284c7);
}

.dot-default {
  background: #9a6b27;
}

.disabled-field >>> .v-input__slot {
  background-color: #f8fafc !important;
  border-color: #e2e8f0 !important;
}

.disabled-field >>> input {
  color: #64748b !important;
  font-weight: 600 !important;
}

.rate-lock-pill {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 1px 8px;
  font-size: 11.5px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: all 0.15s ease;
}

.rate-lock-pill:hover {
  border-color: #cbd5e1;
  color: #1e293b;
}

.rate-lock-pill.is-locked {
  background-color: #fff7ed;
  border-color: #fed7aa;
  color: #9a6b27;
}

/* Custom Table */
.table-responsive {
  width: 100%;
  overflow-x: auto;
  padding-bottom: 4px;
}

.table-responsive::-webkit-scrollbar {
  height: 5px;
  width: 5px;
}

.table-responsive::-webkit-scrollbar-track {
  background: #f8fafc;
  border-radius: 10px;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #cbd5e1 !important;
  border-radius: 10px;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #94a3b8 !important;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.custom-table thead {
  background-color: #f8fafc;
}

.custom-table th {
  padding: 13px 16px;
  font-size: 11.5px;
  font-weight: 600;
  color: #475569;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  white-space: nowrap;
  border-bottom: 1px solid #e2e8f0;
}

.custom-table td {
  padding: 14px 16px;
  font-size: 13.5px;
  color: #1e293b;
  border-bottom: 1px solid #f1f5f9;
  white-space: nowrap;
  vertical-align: middle;
}

.table-row {
  transition: background-color 0.12s ease;
}

.table-row:hover {
  background-color: #fafaf9;
}

.cell-muted {
  color: #94a3b8;
  font-size: 12.5px;
}

.code-pill {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12.5px;
  font-weight: 600;
  color: #0f172a;
  background-color: #f1f5f9;
  padding: 3px 8px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  display: inline-block;
}

/* Action Icon Buttons */
.action-icon-btn {
  width: 32px !important;
  height: 32px !important;
  border-radius: 8px !important;
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff !important;
  transition: all 0.15s ease !important;
}

.edit-action-btn:hover {
  background-color: #fff7ed !important;
  border-color: #fed7aa !important;
}

.delete-action-btn:hover {
  background-color: #fef2f2 !important;
  border-color: #fecaca !important;
}

.qr-action-btn:hover {
  background-color: #eff6ff !important;
  border-color: #dbeafe !important;
}

/* Empty State */
.empty-icon-circle {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  background-color: #fff7ed;
  border: 1px solid #fed7aa;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.empty-title {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.empty-subtitle {
  font-size: 13px;
  color: #64748b;
}

/* Totals Action Strip */
.totals-action-strip {
  background-color: #ffffff;
  border-top: 1px solid #f1f5f9;
}

.summary-pill {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 7px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.summary-pill-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-amber {
  background-color: #fff7ed;
  border: 1px solid #fed7aa;
}

.badge-golden {
  background-color: #fffbeb;
  border: 1px solid #fef3c7;
}

.badge-green {
  background-color: #ecfdf5;
  border: 1px solid #a7f3d0;
}

.text-green {
  color: #16a34a !important;
}

.summary-pill-label {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.summary-pill-val {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

.unit {
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
}

.text-amber-dark {
  color: #b45309 !important;
}

.text-dark {
  color: #0f172a !important;
}

.text-muted-dark {
  color: #475569 !important;
}

/* Dialog Styles */
.dialog-card {
  border-radius: 16px !important;
  background-color: #ffffff;
}

.dialog-header {
  background-color: #ffffff;
  border-bottom: 1px solid #f1f5f9;
}

.dialog-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  line-height: 1.3;
}

.dialog-subtitle {
  font-size: 12.5px;
  color: #64748b;
  margin-top: 2px;
}

.dialog-footer {
  background-color: #ffffff;
  border-top: 1px solid #f1f5f9;
}

.delete-icon-circle {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.qr-code-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.gap-1 {
  gap: 4px;
}

.gap-2 {
  gap: 8px;
}

.gap-3 {
  gap: 12px;
}
</style>
